module.exports = __webpack_public_path__ + "static/img/pump_manual.b10e4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base_layer_img/pump_manual.png
// module id = 5p56
// module chunks = 1